
































import { Component, Vue } from 'vue-property-decorator'
import type { LibraryCategory, LibrarySubcategory, LibraryCategoryArticle } from '~/domains/library/Library.types'
import type { Route } from 'vue-router/types/router'

import { useLibraryService } from '~/domains/library/LibraryService'

import LibrarySubcategories from '~/components/forSpecificPage/library/LibrarySubcategories.vue'
import LibraryArticleList from '~/components/forSpecificPage/library/article/LibraryArticleList.vue'
import MainContentWithAd from '~/components/layouts/types/default/MainContentWithAd.vue'
import LibraryHeader from '~/components/forSpecificPage/library/LibraryHeader.vue'
import BrandingCategory from '~/components/forSpecificPage/library/BrandingCategory.vue'

@Component({
  head () {
    return {
      title: `БэбиБлог — полезные статьи на тему «${this.currentSubcategory.name}»`
    }
  },
  components: {
    BrandingCategory,
    LibrarySubcategories,
    LibraryHeader,
    LibraryArticleList,
    MainContentWithAd
  },
  async asyncData ({ params, error, query, $storeModules }) {
    try {
      const {
        currentCategory,
        currentSubcategory,
        articles,
        previousSubcategory,
        previousArticles
      } = await useLibraryService().fetchSubcategoryAndArticles({
        categoryChpu: params.categoryChpu,
        subcategoryChpu: params.subcategoryChpu,
        preview: query.preview as string,
        id: params.id
      }, $storeModules.advertising)

      return {
        articles,
        currentCategory,
        currentSubcategory,
        previousSubcategory,
        previousArticles
      }
    } catch (e) {
      return error({
        statusCode: 404,
        message: e.message
      })
    }
  },
  beforeRouteLeave (to: Route, from: Route, next) {
    this.$storeModules.advertising.setIsLibraryBrand(false)
    next()
  }
})
export default class LibrarySubcategoryPage extends Vue {
  currentCategory: LibraryCategory
  currentSubcategory: LibrarySubcategory
  articles: LibraryCategoryArticle[]
  previousSubcategory: LibrarySubcategory | null
  previousArticles: LibraryCategoryArticle[]

  get breadcrumbs () {
    return [
      {
        text: 'Полезные статьи',
        to: '/library'
      },
      {
        text: this.currentCategory.name,
        to: `/library/${this.currentCategory.chpuName}`
      }
    ]
  }

  get previousSubcategoryArray () {
    return this.previousSubcategory
      ? [this.previousSubcategory]
      : []
  }
}
